'use client';

import React, { useState, useEffect } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';

interface VideoSlide {
  id: number;
  videoUrl: string;
}

interface HeroVideoSliderProps {
  autoplayInterval?: number;
}

const HeroVideoSlider = ({
  autoplayInterval = 10000,
}: HeroVideoSliderProps) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Three video slides - only URLs, no text content
  const videoSlides: VideoSlide[] = [
    {
      id: 1,
      videoUrl: 'http://www.celine-claire-cosmetic.pro/wp-content/uploads/2026/01/celine-turn.mp4',
    },
    {
      id: 2,
      videoUrl: 'http://www.celine-claire-cosmetic.pro/wp-content/uploads/2026/01/celine-round.mp4',
    },
    {
      id: 3,
      videoUrl: 'http://www.celine-claire-cosmetic.pro/wp-content/uploads/2026/01/celie-brown.mp4',
    },
  ];

  // Auto-advance slides
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % videoSlides.length);
    }, autoplayInterval);

    return () => clearInterval(interval);
  }, [autoplayInterval, videoSlides.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + videoSlides.length) % videoSlides.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % videoSlides.length);
  };

  const currentVideo = videoSlides[currentSlide];

  return (
    <div data-component-id="src/app/product-catalog/components/HeroVideoSlider.tsx:60:4" data-component-path="src/app/product-catalog/components/HeroVideoSlider.tsx" data-component-line="60" data-component-end-line="108" data-component-file="HeroVideoSlider.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20w-full%20h-%5B300px%5D%20sm%3Ah-%5B400px%5D%20md%3Ah-%5B500px%5D%20lg%3Ah-%5B600px%5D%20overflow-hidden%20bg-black%22%7D" className="relative w-full h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px] overflow-hidden bg-black">
      {/* Video Container - Full Width */}
      <div data-component-id="src/app/product-catalog/components/HeroVideoSlider.tsx:62:6" data-component-path="src/app/product-catalog/components/HeroVideoSlider.tsx" data-component-line="62" data-component-end-line="74" data-component-file="HeroVideoSlider.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%22%7D" className="absolute inset-0">
        <video data-component-id="src/app/product-catalog/components/HeroVideoSlider.tsx:63:8" data-component-path="src/app/product-catalog/components/HeroVideoSlider.tsx" data-component-line="63" data-component-end-line="73" data-component-file="HeroVideoSlider.tsx" data-component-name="video" data-component-content="%7B%22elementName%22%3A%22video%22%2C%22className%22%3A%22w-full%20h-full%20object-cover%22%2C%22textContent%22%3A%22Your%20browser%20does%20not%20support%20the%20video%20tag.%22%7D"
          key={currentVideo.videoUrl}
          className="w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          <source data-component-id="src/app/product-catalog/components/HeroVideoSlider.tsx:71:10" data-component-path="src/app/product-catalog/components/HeroVideoSlider.tsx" data-component-line="71" data-component-end-line="71" data-component-file="HeroVideoSlider.tsx" data-component-name="source" data-component-content="%7B%22elementName%22%3A%22source%22%2C%22type%22%3A%22video%2Fmp4%22%7D" src={currentVideo.videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Left Arrow Control */}
      <button data-component-id="src/app/product-catalog/components/HeroVideoSlider.tsx:77:6" data-component-path="src/app/product-catalog/components/HeroVideoSlider.tsx" data-component-line="77" data-component-end-line="83" data-component-file="HeroVideoSlider.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22absolute%20left-4%20top-1%2F2%20-translate-y-1%2F2%20z-10%20bg-%5B%23fcb340%5D%20hover%3Abg-white%20p-2%20transition-colors%20group%22%7D"
        onClick={goToPrevious}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-10 bg-[#fcb340] hover:bg-white p-2 transition-colors group"
        aria-label="Previous slide"
      >
        <ChevronLeftIcon data-component-id="src/app/product-catalog/components/HeroVideoSlider.tsx:82:8" data-component-path="src/app/product-catalog/components/HeroVideoSlider.tsx" data-component-line="82" data-component-end-line="82" data-component-file="HeroVideoSlider.tsx" data-component-name="ChevronLeftIcon" data-component-content="%7B%22elementName%22%3A%22ChevronLeftIcon%22%2C%22className%22%3A%22w-6%20h-6%20text-black%20transition-colors%22%7D" className="w-6 h-6 text-black transition-colors" />
      </button>

      {/* Right Arrow Control */}
      <button data-component-id="src/app/product-catalog/components/HeroVideoSlider.tsx:86:6" data-component-path="src/app/product-catalog/components/HeroVideoSlider.tsx" data-component-line="86" data-component-end-line="92" data-component-file="HeroVideoSlider.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22absolute%20right-4%20top-1%2F2%20-translate-y-1%2F2%20z-10%20bg-%5B%23fcb340%5D%20hover%3Abg-white%20p-2%20transition-colors%20group%22%7D"
        onClick={goToNext}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-[#fcb340] hover:bg-white p-2 transition-colors group"
        aria-label="Next slide"
      >
        <ChevronRightIcon data-component-id="src/app/product-catalog/components/HeroVideoSlider.tsx:91:8" data-component-path="src/app/product-catalog/components/HeroVideoSlider.tsx" data-component-line="91" data-component-end-line="91" data-component-file="HeroVideoSlider.tsx" data-component-name="ChevronRightIcon" data-component-content="%7B%22elementName%22%3A%22ChevronRightIcon%22%2C%22className%22%3A%22w-6%20h-6%20text-black%20transition-colors%22%7D" className="w-6 h-6 text-black transition-colors" />
      </button>

      {/* Slide Indicators - Bottom Center */}
      <div data-component-id="src/app/product-catalog/components/HeroVideoSlider.tsx:95:6" data-component-path="src/app/product-catalog/components/HeroVideoSlider.tsx" data-component-line="95" data-component-end-line="107" data-component-file="HeroVideoSlider.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20bottom-4%20sm%3Abottom-6%20left-1%2F2%20-translate-x-1%2F2%20flex%20gap-3%20z-10%22%7D" className="absolute bottom-4 sm:bottom-6 left-1/2 -translate-x-1/2 flex gap-3 z-10">
        {videoSlides.map((slide, index) => (
          <button data-component-id="src/app/product-catalog/components/HeroVideoSlider.tsx:97:10" data-component-path="src/app/product-catalog/components/HeroVideoSlider.tsx" data-component-line="97" data-component-end-line="105" data-component-file="HeroVideoSlider.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            key={slide.id}
            onClick={() => goToSlide(index)}
            className={`transition-all duration-[4000ms] rounded-none ${
              index === currentSlide
                ? 'bg-[#fcb340] w-10 sm:w-12 h-3' :'bg-[#fcb340]/50 hover:bg-[#fcb340]/70 w-3 h-3'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroVideoSlider;